export default __webpack_public_path__ + "static/media/AlexandraLovelace.f5c71cd6.png";